import { ref, computed } from 'vue';
import axios from 'axios';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

// A LAN party seat offer, shared by the classic SeatOfferModal and the v5 one.
export default function useSeatOffer() {
  const store = useStore();
  const router = useRouter();
  const busy = ref(false);

  const offer = computed(() => store.getters.matchmakingContext?.lan_party_offer);

  function decline() {
    const entry = store.getters.matchmakingParty?.queue_entry;
    busy.value = true;
    const request = entry
      ? axios.put(`/matchmaking/queue_entries/${entry.id}`, { queue_entry: { lan_party_offer_declined: true } })
      : Promise.resolve();
    request.catch(() => {}).finally(() => {
      store.commit('clearMatchmakingOffer');
      busy.value = false;
    });
  }

  function accept() {
    const { uuid, creator } = offer.value;
    busy.value = true;
    axios.post(`/matchmaking/lan_parties/${uuid}/members`, { guest: true }).then(() => {
      store.commit('clearMatchmakingOffer');
      router.push({ name: 'LanPartyPage', params: { slug: creator.slug } });
    }).catch(() => {}).finally(() => {
      busy.value = false;
    });
  }

  return {
    busy, offer, decline, accept,
  };
}
